import { useQuery } from '@tanstack/react-query';
import { GaitMlResults, MuxAnimatedGifParams, MuxAnimatedGifUrlResponse } from '@companion-professional/dctypes';
import { getAnimatedGifUrls } from '../lib/api';

// useGetAnimatedGifUrls is a custom hook that fetches animated GIF URLs for a given item ID and clip parameters.
export const useGetAnimatedGifUrls = (itemId: string, clipParams: MuxAnimatedGifParams[]) => {
  const {
    isPending,
    error,
    data: clips = []
  } = useQuery<MuxAnimatedGifUrlResponse[]>({
    queryKey: ['animated-gif-urls', itemId],
    queryFn: () => getAnimatedGifUrls(itemId, clipParams)
  });

  return {
    isPending,
    error,
    clips
  };
};

// useGetAnimatedGifUrlsForGaitMlResult is a custom hook that fetches animated GIF URLs for a given Gait ML result.
// TODO: This limits the number of clips to the value of `limit`, which will return the first `limit` clips from the
//   Gait ML result.  These clips are currently ordered by significance, so this should be fine, but in the future we
//   may want add a value to the GaitMlResultClip type that indicates the significance of the clip, and then sort
//   the clips by that value before passing them to this hook.
export const useGetAnimatedGifUrlsForGaitMlResult = (
  itemId: string,
  gaitMlResult: GaitMlResults,
  width = 160,
  fps = 15,
  limit = 4
) => {
  const clipParams = gaitMlResult.relevant_clips.slice(0, limit).map((clip) => ({
    name: `clip-${clip.start_sec}-${clip.end_sec}`,
    start_sec: Math.floor(clip.start_sec),
    end_sec: Math.ceil(clip.end_sec),
    width,
    fps
  }));

  const { isPending, error, clips } = useGetAnimatedGifUrls(itemId, clipParams);

  return {
    isPending,
    error,
    clips
  };
};
